import React from 'react';

const SectionTopBanners = ({ banners }) => {
  if (!banners?.length) return null;

  return (
    <div className="container col-md-8 col-lg-6 p-0">
      <div className="d-flex overflow-auto">
        {banners.map((banner) => {
          return (
            <div key={banner.src} className="place_square-box ml-2 mt-3">
              {banner.href ? (
                <a href={banner.href} target="_blank" rel="noopener noreferrer">
                  <img src={banner.src} alt={banner.alt} className="place_square-img"/>
                </a>
              ) : (
                <div role="button" onClick={banner.onClick} style={{ cursor: 'pointer' }}>
                  <img src={banner.src} alt={banner.alt} className="place_square-img"/>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SectionTopBanners;
